import React from "react";
import ServiceCard from "./service.card";
import { SERVICE_DATA } from "../../constant/service-data";
import Button from "../button/button.component";

const Service = () => {
  const handleEstimateProject = () => {
    window.location.href = "mailto:tarachand122333@gmail.com";
  };
  return (
    <div className="flex py-20 w-full justify-center text-black" id="service">
      <div className="flex max-w-7xl w-full flex-col px-4 lg:px-0 gap-20 pt-12">
        <h1 className="text-4xl font-bold text-black">Product Services</h1>
        <div className="flex flex-col gap-12">
          <h1 className="text-xl lg:text-2xl text-black">
            Build your competitive edge through engineering. YTC aligns science,
            technology and domain expertise to solve real-world problems,
            empower human productivity and drive growth.
          </h1>
          <h1 className="text-2xl text-black">
            For nearly four decades, our unrivaled capabilities, scale and
            partner ecosystem have enabled clients to engineer a bridge from
            what is to what could be.
          </h1>
          <div className="flex gap-8 flex-col md:flex-row">
            {SERVICE_DATA.length > 0 &&
              SERVICE_DATA.map((item, index) => (
                <ServiceCard {...item} key={index} />
              ))}
          </div>
          <div>
            <h1 className="text-xl lg:text-2xl text-black">
              We create custom web and app solutions with custome technologies
              tailored to your business needs, helping you achieve rapid growth.
            </h1>
          </div>

          <div className="flex gap-8 w-full flex-col">
            <h1 className="flex font-bold text-2xl lg:text-3xl text-black">
              Web Development: Craft Outstanding Online Presence with Your Tech
              Company
            </h1>
            <h1 className="flex text-gray-600 text-xl">
              In today’s digital era, a compelling online presence is crucial
              for success. At YTC, a premier web app development company, we
              specialize in offering cutting-edge web development services. Our
              goal is to create responsive, fast-loading, and user-friendly
              websites that not only meet but exceed your expectations. Our
              expertise in custom web development services and web application
              development services ensures that your website is not just a
              platform but a powerful tool to propel your business forward.
            </h1>

            <h1 className="flex font-bold text-2xl lg:text-3xl text-black pt-6">
              Our Web Development Services
            </h1>

            <div className="flex gap-6 flex-col">
              <p className="text-xl text-gray-600">
                At YTC, we understand that a great website serves as the
                cornerstone of your digital presence. Here’s how we can help you
                shine online:
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">
                  1. Custom Web Development Services:{" "}
                </b>
                We believe in creating unique solutions tailored to your
                specific business needs. Our custom web development services are
                designed to build websites that reflect your brand’s
                personality, meet your specific functionalities, and provide an
                exceptional user experience.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">
                  2. Web Application Development Services:{" "}
                </b>
                Beyond traditional websites, we excel in developing robust web
                applications that enhance user interaction and functionality.
                Whether you need a complex e-commerce platform, an interactive
                customer portal, or a sophisticated management system, our web
                application development services offer comprehensive solutions
                that integrate seamlessly with your business operations.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">3. Responsive Design: </b>In a
                mobile-first world, a responsive website is essential. Our web
                designs ensure that your site looks and functions perfectly on
                all devices, from desktops to smartphones. This adaptability
                improves user experience and boosts your SEO rankings.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">4. Speed Optimization: </b>We
                understand that speed is a vital aspect of website performance.
                Our development process includes advanced techniques to ensure
                your website loads quickly, reducing bounce rates and increasing
                user satisfaction.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">5. SEO-Friendly Websites: </b>Our web
                development approach incorporates SEO best practices to ensure
                your site ranks well in search engines. From optimized code and
                fast loading times to mobile-friendly designs, we make sure your
                website has a solid foundation for your SEO efforts.
              </p>
            </div>

            <h1 className="flex font-bold text-2xl lg:text-3xl text-black pt-8">
              Why Choose YTC for Web Development?
            </h1>

            <div className="flex gap-6 flex-col">
              <p className="text-xl text-gray-600">
                <b className="text-black">Expertise and Experience: </b>As a
                leading web app development company, we have a team of
                experienced developers, designers, and project managers who
                ensure the highest quality of work from start to finish.{" "}
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">Customization and Innovation: </b>We
                pride ourselves on delivering customized solutions that meet the
                unique challenges and opportunities of your business. Our
                innovative approaches keep you ahead in the competitive market.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">Comprehensive Strategy: </b>Our
                services go beyond coding. We take a holistic view of your
                business’s online needs and develop strategies that encompass
                design, user experience, functionality, and marketing.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">Ongoing Support and Maintenance: </b>
                Our relationship with clients doesn’t end with the launch of a
                website. We provide ongoing support and maintenance to ensure
                your site remains up-to-date and continues to perform optimally.
              </p>
            </div>

            <h1 className="flex font-bold text-2xl lg:text-3xl text-black pt-8">
              Implementing Your Vision with Your Tech Company
            </h1>

            <p className="text-xl text-gray-600">
              Our process for web development is meticulous and client-focused:
            </p>
            <div className="flex gap-6 flex-col">
              <p className="text-xl text-gray-600">
                <b className="text-black">1. Discovery and Planning: </b>We
                start with a deep dive into your business, market, and
                objectives. This phase helps us plan a website that truly aligns
                with your vision.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">2. Design and Development: </b>Our
                designers and developers work hand in hand to create a site that
                is aesthetically pleasing and functionally rich. We keep you
                involved throughout the process, ensuring the final product
                reflects your expectations.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">3. Testing and Launch: </b>Before
                launch, your website undergoes rigorous testing on multiple
                devices and browsers to ensure flawless performance. Only after
                thorough quality checks do we go live.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">4. Training and Handover: </b>We
                provide training sessions for your team to manage the website’s
                basic functions and ensure you are comfortable with the new
                system.
              </p>
              <p className="text-xl text-gray-600">
                <b className="text-black">5. Post-Launch Support: </b>We
                continue to monitor the website’s performance and are ready to
                address any challenges that arise post-launch.
              </p>
            </div>

            <h1 className="flex font-bold text-2xl lg:text-3xl text-black pt-8">
              Conclusion
            </h1>

            <p className="text-xl text-gray-600">
              At Your Tech Company, your online success is our priority. Our
              comprehensive web development services ensure your website stands
              out in a crowded online space, capturing attention and driving
              results. Whether you need a basic website or a complex web
              application, trust us to deliver a solution that exceeds your
              digital aspirations. Let’s build something remarkable together.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4 p-10 bg-[#07207c] rounded-3xl relative">
          <h1 className="text-xl lg:text-3xl text-white capitalize">Lets work together</h1>
          <h1 className="text-2xl lg:text-5xl text-white font-bold">
            Need a Successful
          </h1>
          <h1 className="text-2xl lg:text-5xl text-white font-bold">
            Your Project?
          </h1>
          <div className="w-max">
            <Button onClick={handleEstimateProject}>Estimate Project</Button>
          </div>
          <img
            src="https://itcroctheme.com/wp/demos/themes/xotric-final/wp-content/uploads/2023/09/newslettar_img.png"
            className="absolute right-0 w-48 lg:w-96"
          />
        </div>
      </div>
    </div>
  );
};

export default Service;
